var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyAdBlocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M47.5 7.5h-35a5 5 0 0 0-5 5v35a5 5 0 0 0 5 5h35a5 5 0 0 0 5-5v-35a5 5 0 0 0-5-5ZM22.5 22.5l15 15M37.5 22.5l-15 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyAdBlocker);
export default __webpack_public_path__ + "static/media/privacy-ad-blocker.f904ebe06751847f082342ced2ccb97d.svg";
export { ForwardRef as ReactComponent };